module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAACXBIWXMAAAsSAAALEgHS3X78AAAAW0lEQVQ4y2P8//8/AyWAiYFCgNcAxk6G/wPrgiFqAK6AwyWOzQWO6IqhfEecBiBr+F/OcADZEJhmqDiGa7CGAcwQmIuQNaMDFlwSUE2MNI8FFlKSLdbYGfDcCACZHCIMoPTnHQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/form/icon_download.png
// module id = 1145
// module chunks = 50